(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pack-selector"] && !Shopify.designMode) return;
  try {
    const SELECTED_CLASS = 'is-selected';
  const DEFAULT_QUANTITY = 1;

  const getPackSize = (packButton) => {
    const packSize = parseInt(packButton.dataset.packSize, 10);
    return Number.isNaN(packSize) || packSize < DEFAULT_QUANTITY ? DEFAULT_QUANTITY : packSize;
  };

  const highlightSelectedPack = (packButtons, selectedButton) => {
    packButtons.forEach((packButton) => {
      const isSelected = packButton === selectedButton;
      packButton.setAttribute('aria-pressed', String(isSelected));
      packButton.classList.toggle(SELECTED_CLASS, isSelected);
    });
  };

  const updateProductQuantity = (quantityInput, quantity) => {
    quantityInput.value = quantity;
    quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
  };

  const parseMoneyString = (value) => {
    if (!value) return null;
    const str = String(value).trim();
    const num = parseFloat(str.replace(/[^0-9.]/g, ''));
    if (Number.isNaN(num)) return null;
    const prefix = str.match(/^[^\d.-]*/)?.[0] || '';
    return { num, prefix };
  };

  const formatScaledMoneyString = (value, multiplier) => {
    const parsed = parseMoneyString(value);
    if (!parsed) return value;
    const scaled = parsed.num * multiplier;
    const formatted = Number.isInteger(scaled) ? String(Math.round(scaled)) : String(parseFloat(scaled.toFixed(2)));
    return `${parsed.prefix}${formatted}`;
  };

  const formatCentsAsMoney = (cents) => {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents)
        .replace(/(\.\d*?)0+(?=\D|$)/, '$1')
        .replace(/\.00(?=\D|$)/, '');
    }
    const dollars = cents / 100;
    return dollars % 1 === 0 ? `$${Math.round(dollars)}` : `$${parseFloat(dollars.toFixed(2))}`;
  };

  const getUnitPrices = (group) => {
    const widget = group.querySelector('subscription-widget');
    if (widget) {
      const subRadio = widget.querySelector('input[value="subscription"]');
      const otpRadio = widget.querySelector('input[value="onetime"]');
      if (subRadio?.checked) {
        return {
          price: subRadio.dataset.subPrice,
          comparePrice: subRadio.dataset.comparePrice || null,
          isSubscription: true
        };
      }
      if (otpRadio?.checked) {
        return {
          price: otpRadio.dataset.price,
          comparePrice: null,
          isSubscription: false
        };
      }
    }

    const btn = group.querySelector('[id^="pdp-add-to-cart-btn-"]');
    if (!btn) return null;

    const priceEl = btn.querySelector('.btn-price');
    if (priceEl?.hasAttribute('data-custom-price')) {
      const customCompareEl = btn.querySelector('.btn-custom-compare-price');
      return {
        price: priceEl.getAttribute('data-custom-price'),
        comparePrice: customCompareEl?.getAttribute('data-custom-compare') || null,
        isSubscription: false
      };
    }

    const unitPriceCents = parseInt(btn.dataset.unitPriceCents, 10);
    if (Number.isNaN(unitPriceCents)) return null;

    const unitComparePriceCents = parseInt(btn.dataset.unitComparePriceCents, 10);
    return {
      priceCents: unitPriceCents,
      comparePriceCents: !Number.isNaN(unitComparePriceCents) && unitComparePriceCents > unitPriceCents
        ? unitComparePriceCents
        : null,
      isSubscription: false
    };
  };

  const applyAtcButtonPrices = (btn, price, comparePrice, isSubscription) => {
    const priceEl = btn.querySelector('.btn-price');
    const compareEl = btn.querySelector('.btn-compare-price');
    const customCompareEl = btn.querySelector('.btn-custom-compare-price');

    if (isSubscription) {
      if (priceEl && price) priceEl.innerHTML = price;
      if (customCompareEl) customCompareEl.style.display = 'none';
    } else {
      if (priceEl && price) priceEl.innerHTML = price;
      if (customCompareEl) {
        customCompareEl.style.display = comparePrice ? 'inline' : 'none';
        if (comparePrice) customCompareEl.innerHTML = comparePrice;
      }
    }

    if (compareEl) {
      if (comparePrice && (!customCompareEl || isSubscription)) {
        compareEl.innerHTML = comparePrice;
        compareEl.style.display = 'inline';
      } else {
        compareEl.style.display = 'none';
      }
    }
  };

  const getPackSizeFromGroup = (group) => {
    const quantityInput = group.querySelector('[name="quantity"]');
    return quantityInput ? parseInt(quantityInput.value, 10) || DEFAULT_QUANTITY : DEFAULT_QUANTITY;
  };

  const updateAtcButtonPrice = (group) => {
    const btn = group.querySelector('[id^="pdp-add-to-cart-btn-"]');
    const unitPrices = getUnitPrices(group);
    if (!btn || !unitPrices) return;

    const packSize = getPackSizeFromGroup(group);
    let price;
    let comparePrice = null;

    if (unitPrices.price) {
      price = formatScaledMoneyString(unitPrices.price, packSize);
      comparePrice = unitPrices.comparePrice
        ? formatScaledMoneyString(unitPrices.comparePrice, packSize)
        : null;
    } else {
      price = formatCentsAsMoney(unitPrices.priceCents * packSize);
      comparePrice = unitPrices.comparePriceCents
        ? formatCentsAsMoney(unitPrices.comparePriceCents * packSize)
        : null;
    }

    applyAtcButtonPrices(btn, price, comparePrice, unitPrices.isSubscription);
  };

  const selectPack = (packButtons, quantityInput, selectedButton, group) => {
    updateProductQuantity(quantityInput, getPackSize(selectedButton));
    highlightSelectedPack(packButtons, selectedButton);
    updateAtcButtonPrice(group);
  };

  // Each product (buy box toggle wrapper) has its own pack buttons and quantity
  // input, so the logic is scoped per group. This keeps every product's own
  // pack selected, including after switching products with the product toggle.
  const initPackSelectorGroup = (group) => {
    const packButtons = Array.from(group.querySelectorAll('.pack-selector-btn'));
    const quantityInput = group.querySelector('[name="quantity"]');
    if (packButtons.length === 0 || !quantityInput) return;

    packButtons.forEach((packButton) => {
      packButton.addEventListener('click', () => {
        selectPack(packButtons, quantityInput, packButton, group);
      });
    });

    const preselectedPack = packButtons.find((packButton) => packButton.classList.contains(SELECTED_CLASS));
    selectPack(packButtons, quantityInput, preselectedPack || packButtons[0], group);
  };

  const refreshAllAtcButtonPrices = () => {
    const groups = document.querySelectorAll('.buy-box-toggle-wrapper');
    if (groups.length > 0) {
      groups.forEach(updateAtcButtonPrice);
    } else {
      updateAtcButtonPrice(document);
    }
  };

  document.addEventListener('pdp:price_changed', () => {
    setTimeout(refreshAllAtcButtonPrices, 0);
  });
  document.addEventListener('pdp:selling_plan_changed', () => {
    setTimeout(refreshAllAtcButtonPrices, 0);
  });

  const initPackSelector = () => {
    const groups = document.querySelectorAll('.buy-box-toggle-wrapper');
    if (groups.length > 0) {
      groups.forEach(initPackSelectorGroup);
    } else {
      initPackSelectorGroup(document);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPackSelector);
  } else {
    initPackSelector();
  }
  } catch(e) { console.error(e); }
})();

})();
